<form [formGroup]="formRef" autocomplete="off" class="space-y-4">
  <!-- Business Name -->
  <div class="grid grid-cols-2 items-center">
    <oiq-form-input
      label="Business Name"
      formControlName="name"
      placeholder="Client Business Name"
      [class.ocr-prefilled]="isOcrPrefilled('businessName')"></oiq-form-input>
    @if (showBackButton()) {
      <div class="text-right">
        <button
          class="oiq-button oiq-button--link text-sm font-medium text-primary"
          (click)="onBackClicked()">
          <span class="material-symbols-outlined text-sm">open_in_new</span>
          <!--          <svg-->
          <!--            width="14"-->
          <!--            height="14"-->
          <!--            viewBox="0 0 14 14"-->
          <!--            fill="none"-->
          <!--            xmlns="http://www.w3.org/2000/svg">-->
          <!--            <path-->
          <!--              fill-rule="evenodd"-->
          <!--              clip-rule="evenodd"-->
          <!--              d="M9 0.5C8.80109 0.5 8.61032 0.579018 8.46967 0.71967C8.32902 0.860322 8.25 1.05109 8.25 1.25C8.25 1.44891 8.32902 1.63968 8.46967 1.78033C8.61032 1.92098 8.80109 2 9 2H10.94L5.97 6.97C5.83752 7.11217 5.7654 7.30022 5.76883 7.49452C5.77225 7.68882 5.85097 7.87421 5.98838 8.01162C6.12579 8.14903 6.31118 8.22775 6.50548 8.23118C6.69978 8.2346 6.88783 8.16248 7.03 8.03L12 3.06V5C12 5.19891 12.079 5.38968 12.2197 5.53033C12.3603 5.67098 12.5511 5.75 12.75 5.75C12.9489 5.75 13.1397 5.67098 13.2803 5.53033C13.421 5.38968 13.5 5.19891 13.5 5V1.25C13.5 1.05109 13.421 0.860322 13.2803 0.71967C13.1397 0.579018 12.9489 0.5 12.75 0.5H9ZM6.5 2.25C6.5 2.05109 6.42098 1.86032 6.28033 1.71967C6.13968 1.57902 5.94891 1.5 5.75 1.5H3.5C2.70435 1.5 1.94129 1.81607 1.37868 2.37868C0.816071 2.94129 0.5 3.70435 0.5 4.5V10.5C0.5 11.2956 0.816071 12.0587 1.37868 12.6213C1.94129 13.1839 2.70435 13.5 3.5 13.5H9.5C10.2956 13.5 11.0587 13.1839 11.6213 12.6213C12.1839 12.0587 12.5 11.2956 12.5 10.5V8.25C12.5 8.05109 12.421 7.86032 12.2803 7.71967C12.1397 7.57902 11.9489 7.5 11.75 7.5C11.5511 7.5 11.3603 7.57902 11.2197 7.71967C11.079 7.86032 11 8.05109 11 8.25V10.5C11 10.8978 10.842 11.2794 10.5607 11.5607C10.2794 11.842 9.89782 12 9.5 12H3.5C3.10218 12 2.72064 11.842 2.43934 11.5607C2.15804 11.2794 2 10.8978 2 10.5V4.5C2 4.10218 2.15804 3.72064 2.43934 3.43934C2.72064 3.15804 3.10218 3 3.5 3H5.75C5.94891 3 6.13968 2.92098 6.28033 2.78033C6.42098 2.63968 6.5 2.44891 6.5 2.25Z"-->
          <!--              fill="#FF5127" />-->
          <!--          </svg>-->
          <span>Select Existing Client</span>
        </button>
      </div>
    }
  </div>

  <!-- KEEP: Business description -->
  <!--  <oiq-form-text-->
  <!--    label="Business Description"-->
  <!--    formControlName="businessDescription"-->
  <!--    placeholder="Client Business Description"-->
  <!--    class="w-full"-->
  <!--    [textRows]="4"></oiq-form-text>-->

  <!-- Referring ISO section -->
  <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
    <!-- ISO -->
    <oiq-iso-search
      label="Referring ISO"
      [whiteLabelId]="this.configuration()?.whiteLabelId"
      formControlName="isoId">
      @if (createIso) {
        <div>
          <small>No ISOs {{ formRef.get('isoId')?.value ? 'selected' : 'found' }}</small>
        </div>
      }
      @if (!this.configuration()?.whiteLabelId) {
        <div>
          <small>Please select a White Label in order to choose a Referring ISO</small>
        </div>
      }
    </oiq-iso-search>

    <!-- SALES REP -->
    <oiq-iso-sales-rep-select
      formControlName="isoSalesRepresentativeId"
      [isoId]="formRef.isoId$ | async"></oiq-iso-sales-rep-select>
  </div>

  <!-- Contacts section header -->
  <div class="flex flex-row items-center justify-between gap-4">
    <h4 class="text-base font-medium text-gray-800">Contacts</h4>
    <button
      type="button"
      class="oiq-button oiq-button--link p-0 text-sm font-medium text-primary hover:bg-transparent"
      (click)="formRef.addContact(false)">
      <span class="material-symbols-outlined text-sm">add</span>
      <span>Add Contact</span>
    </button>
  </div>

  <!-- Client contacts section -->
  <div formArrayName="clientContacts" class="space-y-4">
    @for (_contact of formRef.clientContacts.controls; track _contact.index; let i = $index) {
      <div
        [formGroup]="_contact"
        class="flex flex-row gap-4 rounded-md border border-gray-4 bg-gray-6 px-4 py-4 pt-4">
        <div
          class="align-content-start grid flex-grow grid-cols-2 items-start gap-x-4 lg:grid-cols-4">
          <oiq-form-input
            label="Contact First Name"
            formControlName="firstName"
            placeholder="Enter first name"
            inputTrim
            [class.ocr-prefilled]="isOcrPrefilled('firstName')"></oiq-form-input>

          <oiq-form-input
            label="Contact Last Name"
            formControlName="lastName"
            placeholder="Enter last name"
            inputTrim
            [class.ocr-prefilled]="isOcrPrefilled('lastName')"></oiq-form-input>

          <div class="col-span-2 flex flex-nowrap gap-4 pt-4 lg:pt-7">
            <oiq-form-checkbox
              label="Primary Contact"
              formControlName="isPrimaryContact"></oiq-form-checkbox>
            <oiq-form-checkbox label="Owner" formControlName="isOwner"></oiq-form-checkbox>
            <oiq-form-checkbox label="Primary Owner" formControlName="primary"></oiq-form-checkbox>
          </div>
        </div>

        <div class="my-auto h-7 w-12 border-l border-gray-3 pl-2" [class.border-l]="i > 0">
          @if (i > 0) {
            <button
              type="button"
              class="oiq-button oiq-button--link px-2 text-sm font-medium"
              (click)="formRef.clientContacts.remove(i)">
              <span class="material-symbols-outlined text-sm">close</span>
            </button>
          }
        </div>
      </div>
    }
  </div>
</form>

<!-- Validation errors -->
@if (formRef.clientContacts.hasError('contactsValidationError')) {
  <div class="mt-2 text-sm text-red-600">
    {{ formRef.clientContacts.error['contactsValidationError'] }}
  </div>
}
